import { wouldCreateCycle } from '../core/cycle-detector.js';
import { buildDependencyGraph } from '../core/dependency-graph.js';
import type {
  ConstraintCtx,
  ConstraintResult,
  DragConstraint,
} from '../extensions/index.js';
import type { BarState } from '../extensions/types.js';

/**
 * Rejects a `link` proposal when adding the edge would create a cycle
 * in the dependency graph. Only activates for `intent === 'link'`; all
 * other intents pass through unchanged.
 */
export class DependencyAcyclicConstraint implements DragConstraint {
  readonly id = 'streamlain.gantt.constraint.dependency-acyclic';
  readonly priority = 0;

  validate(proposed: BarState, ctx: ConstraintCtx): ConstraintResult {
    if (ctx.intent !== 'link') return { allowed: true };

    const target = ctx.linkTargetRowId;
    if (!target) return { allowed: true };

    const projection = ctx.view.projectRows({ scope: 'whole-database' });
    if (!projection.complete) {
      return {
        allowed: false,
        warning: 'com.streamlain.gantt.dep.incomplete-projection',
      };
    }

    const rows = projection.rows;
    const graph = buildDependencyGraph(ctx.view, rows);
    if (wouldCreateCycle(graph, proposed.rowId, target)) {
      return {
        allowed: false,
        warning: 'com.streamlain.gantt.dep.cycle-error',
      };
    }
    return { allowed: true };
  }
}
